import type { ClassValue } from "clsx"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Ensures Polish non-breaking spaces for short prepositions (1-2 chars)
 */
export function formatPolishTypography(text: string): string {
  return text.replace(/(\b[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ]{1,2})\s+/g, '$1\u00A0')
}
